import { render, staticRenderFns } from "./VeJwCiBukaoList.vue?vue&type=template&id=8ec56338&scoped=true"
import script from "./VeJwCiBukaoList.vue?vue&type=script&lang=js"
export * from "./VeJwCiBukaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec56338",
  null
  
)

export default component.exports